import { render, staticRenderFns } from "./fenxi.vue?vue&type=template&id=f6490cc8&scoped=true&"
import script from "./fenxi.vue?vue&type=script&lang=js&"
export * from "./fenxi.vue?vue&type=script&lang=js&"
import style0 from "./fenxi.vue?vue&type=style&index=0&id=f6490cc8&prod&lang=scss&"
import style1 from "./fenxi.vue?vue&type=style&index=1&id=f6490cc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6490cc8",
  null
  
)

export default component.exports